<template>
  <div class="app-main-content hr-export">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" :lazy="true" type="card" style="width:100%;">
        <el-tab-pane v-if="tabHrRealGpReportIsShowed" :label="'HR Real GP Report'" name="hrRealGpReport">
          <tab-hr-real-gp-report ref="hrRealGpReport" :copy-month-list="copyMonthList" :latest-monthly-date="latestMonthlyDate" :is-show="hrRealGpReportIsShow" :query-branch-list="queryBranchList" :query-dept-id-list="queryDeptIdList" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import tabHrRealGpReport from './tabHrRealGpReport'
import { getLoading } from '@/utils/utilBaseElement'
import { loadSearchConditions } from '@/api/clearing/pillReport'
import { cacheKeys, getCacheListByKey, getFilterCacheList } from '@/utils/basicDataCache'

export default {
  name: 'HrExport',
  components: { tabHrRealGpReport },
  props: {},
  data() {
    return {
      loading: false,
      activeTabName: 'hrRealGpReport',
      tabHrRealGpReportIsShowed: this.$checkPermission(['tab_HrExport_hrGpReport']),
      hrRealGpReportIsShowed: false,
      copyMonthList: [], // copy Month列表
      latestMonthlyDate: null, // 最新月度数据生成时间
      queryBranchList: [], // 查询权限分公司
      queryDeptIdList: [] // 查询权限部门ID
    }
  },
  computed: {
    hrRealGpReportIsShow() {
      if (this.activeTabName === 'hrRealGpReport' && !this.hrRealGpReportIsShowed) {
        this.hrRealGpReportIsShowed = true
      }
      return this.hrRealGpReportIsShowed
    }
  },
  created() {
    this.defaultActiveTabName()
    this.loadInitData()
  },
  methods: {
    defaultActiveTabName() {
      if (this.tabHrRealGpReportIsShowed) {
        this.activeTabName = 'hrRealGpReport'
      }
    },
    loadInitData() {
      this.loading = getLoading()
      loadSearchConditions({ 'hrMark': true }).then(res => {
        if (res.data) {
          this.copyMonthList = res.data.copyMonthList
          this.latestMonthlyDate = res.data.latestMonthlyDate
          // Monthly
          const branchIds = res.data.branchIds || []
          if (branchIds.length === 0) {
            this.queryBranchList = getCacheListByKey(cacheKeys.basic_data_Office_All)
          } else {
            const currentList = getFilterCacheList(cacheKeys.basic_data_Office_All, (item) => {
              return branchIds.includes(item.officeId)
            }) || []
            if (currentList.length !== 0) {
              this.queryBranchList.push(...currentList)
            }
          }
          this.queryDeptIdList = res.data.deptIds
          this.$nextTick(() => {
            this.$refs.hrRealGpReport.setDefaultCondition()
          })
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">

</style>
